import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import {
  LineItemInterface,
  StyledLineItem,
  StyledFlex,
  StyledInfoFlex,
  StyledDetailsFlex
} from './LineItem'
import determineVoucherImage from 'helpers/determineVoucherImage'
import { defined, definedNotNull } from 'shared/presenters/presenter'
import Button from 'library/atoms/Button'
import { Text } from 'library/atoms/Typography'
import { ClassPassPresenter } from 'shared/presenters/ClassPassPresenter'
import Flex from 'shared/library/atoms/Flex'
import Price from 'shared/library/atoms/Price'
import Thumbnail from 'shared/library/atoms/Thumbnail'
import Icon from 'shared/library/atoms/Icon'
import { StyledExpandIcon } from 'library/molecules/DetailsList'

const LineItemClassPass = ({
  item,
  outlet,
  removeItemOnClick,
  removeItemLoading,
  setExpanded,
  expanded
}: LineItemInterface) => {
  const { t } = useTranslation('common')
  const classPass = new ClassPassPresenter(
    definedNotNull(item?.purchased_class_pass?.class_pass)
  )

  // TODO - Introduce data to view item - Issue #3651
  const chargeableReviewData = undefined

  return (
    <StyledLineItem key={classPass.id}>
      <Flex
        alignItems="center"
        onClick={() => {
          if (setExpanded) setExpanded(!expanded)
        }}
      >
        <Thumbnail
          thumbnailSize={40}
          src={determineVoucherImage({
            image: classPass.image,
            keyImage: outlet?.class_pass_key_image
          })}
        />
        <StyledFlex>
          <Text>{classPass.name()}</Text>
          <Flex alignItems="center" gap={3}>
            <Price
              pence={defined(item.price_paid)}
              currency={outlet.currency()}
            />
            <StyledExpandIcon expanded={!!expanded} />
          </Flex>
        </StyledFlex>
      </Flex>
      {expanded && (
        <>
          <StyledDetailsFlex>
            <StyledInfoFlex>
              <Icon name="ticket" size={20} mr={3} />
              <Text color="secondary">
                {t('x-redemptions', { count: classPass.max_redemptions })}
              </Text>
            </StyledInfoFlex>
          </StyledDetailsFlex>
          {(removeItemOnClick || chargeableReviewData) && (
            <>
              <Flex mt={4} justifyContent="end">
                {removeItemOnClick && (
                  <Button
                    variant="tertiary"
                    loading={removeItemLoading}
                    inactive={removeItemLoading}
                    onClick={() => {
                      removeItemOnClick(definedNotNull(item.id))
                    }}
                    aria-label={t('remove-class-pass')}
                  >
                    {t('delete')}
                  </Button>
                )}
              </Flex>
            </>
          )}
        </>
      )}
    </StyledLineItem>
  )
}

export default LineItemClassPass
